import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { CheckCircle2, AlertTriangle, Info, RefreshCw, X } from 'lucide-react';
import { API_URL } from '../lib/api';
import { Button } from './ui/button';

const ICON = { ok: [CheckCircle2, 'text-emerald-600'], alerte: [AlertTriangle, 'text-red-600'], info: [Info, 'text-gray-400'] };
const fetchHealth = () => axios.get(`${API_URL}/api/admin/sante`, { withCredentials: true }).then(r => r.data);

export function SystemHealthPanel() {
    const [h, setH] = useState(null);
    const load = () => fetchHealth().then(setH).catch(() => setH(null));
    useEffect(() => { load(); }, []);
    if (!h) return null;
    return (
        <div className={`rounded-xl border p-4 bg-white ${h.etat === 'alerte' ? 'border-red-200' : 'border-gray-200'}`} data-testid="system-health-panel">
            <div className="flex items-center justify-between mb-2">
                <p className="text-sm font-semibold text-gray-900">Santé du système</p>
                <Button variant="ghost" size="sm" onClick={load} data-testid="system-health-refresh"><RefreshCw className="w-4 h-4" /></Button>
            </div>
            <ul className="space-y-1.5">
                {h.elements.map(e => {
                    const [I, c] = ICON[e.niveau] || ICON.info;
                    return (
                        <li key={e.cle} className="flex items-start gap-2 text-[12px]" data-testid={`system-health-${e.cle}`}>
                            <I className={`w-4 h-4 shrink-0 mt-px ${c}`} />
                            <span><b className="text-gray-800">{e.titre}</b> — <span className="text-gray-600">{e.detail}</span></span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export function SystemHealthAlert() {
    const [h, setH] = useState(null);
    const [hidden, setHidden] = useState(() => sessionStorage.getItem('health-alert-hidden') === '1');
    useEffect(() => {
        const run = () => fetchHealth().then(setH).catch(() => {});
        run();
        const t = setInterval(run, 300000);
        return () => clearInterval(t);
    }, []);
    if (hidden || h?.etat !== 'alerte') return null;
    const first = h.elements.find(e => e.niveau === 'alerte');
    return (
        <div className="mx-4 sm:mx-6 mt-3 flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-[12px] text-red-800" data-testid="system-health-alert">
            <Link to="/coherence" className="flex-1"><AlertTriangle className="inline w-4 h-4 mr-1" /><b>{first.titre}</b> : {first.detail} — voir la santé du système</Link>
            <button onClick={() => { sessionStorage.setItem('health-alert-hidden', '1'); setHidden(true); }} aria-label="Masquer" data-testid="system-health-alert-close"><X className="w-4 h-4" /></button>
        </div>
    );
}
